export default "__VITE_ASSET__DnXjKHID__"